import { render, staticRenderFns } from "./application-reviewers.vue?vue&type=template&id=dbb1e544"
import script from "./application-reviewers.vue?vue&type=script&lang=js"
export * from "./application-reviewers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports